<script lang="ts">
    import InputError from '@/components/InputError.svelte';
    import { Label } from '@/components/ui/label/index.js';
    import * as Dialog from '@/components/ui/dialog';
    import { Button } from '@/components/ui/button';
    import { XIcon } from 'lucide-svelte';
    import type { Snippet } from 'svelte';
    import Debug from '@/components/Debug.svelte';
    import CustomerTable from "@/components/customers/CustomerTable.svelte";

    type Props = {
        label?: string;
        error?: string;
        isOpen?: boolean;
        module?: string | null;
        value?: number | null | boolean | string;
        valLabel?: string | null;
        children: Snippet;
        args?: Record<string, any>;
    };
    let {
        label,
        module = $bindable(),
        value = $bindable(),
        valLabel = $bindable(),
        error,
        isOpen = $bindable(false),
        children,
        ...args
    }: Props = $props();

    let currentConfig = $derived(module ? children[module] : null);
    $inspect("currentConfig", currentConfig, 'module', module, 'children', children);
</script>
<div class="flex flex-col gap-2 w-full">
    {#if label}
        <Label for={label}>{label}</Label>
    {/if}
    <div
        class="border-input w-full bg-background ring-offset-background placeholder:text-muted-foreground focus-visible:ring-ring flex h-10 rounded-md border text-base file:border-0 file:bg-transparent file:text-sm file:font-medium focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:outline-hidden disabled:cursor-not-allowed disabled:opacity-50 md:text-sm"
    >
        <Dialog.Root bind:open={isOpen}>
            <Button
                variant="ghost"
                onclick={() => (isOpen = true)}
                class="h-full flex-1 justify-start truncate"
                disabled={args.disabled}
            >
                {#if valLabel == null}
                    <p class="text-muted-foreground">Select</p>
                {:else}
                    <p class="break-words">{valLabel}</p>
                {/if}
            </Button>
            <Dialog.Content class="max-h-[90svh] max-w-lg sm:max-w-xl md:max-w-3xl lg:max-w-4xl xl:max-w-6xl overflow-auto">
                <Dialog.Header class="space-y-4 ">
                    <Dialog.Title>Select a module and record.</Dialog.Title>
                </Dialog.Header>

                <select bind:value={module} class="border p-2 rounded w-full mb-4">
                    <option value="">-- Choose Module --</option>
                    {#each Object.keys(children) as mod}
                        <option value={mod}>{mod}</option>
                    {/each}
                </select>

                {#if module}
                    <div class="max-h-90svh overflow-auto">
                        <currentConfig.component {...currentConfig.props} />
                    </div>
                {/if}
            </Dialog.Content>
        </Dialog.Root>
        {#if value != null}
            <Button
                variant="ghost"
                onclick={() => {
                    value = null;
                    module = null;
                    valLabel = null;
                    isOpen = false;
                }}><XIcon></XIcon></Button
            >
        {/if}
    </div>
    <InputError message={error} />
</div>

